
export const serviceAreas = [
  { id: 1, name: 'Durban Central', featured: true },
  { id: 2, name: 'Pinetown', featured: true },
  { id: 3, name: 'Westville', featured: true },
  { id: 4, name: 'Hillcrest', featured: true },
  { id: 6, name: 'Phoenix', featured: false },
  { id: 7, name: 'Chatsworth', featured: false },
  { id: 8, name: 'Queensburgh', featured: false },
  { id: 9, name: 'Kloof', featured: false },
  { id: 10, name: 'Gillitts', featured: false },
  { id: 11, name: 'Waterfall', featured: false },
  { id: 12, name: 'Pietermaritzburg', featured: false },
];
